module.exports = __webpack_public_path__ + "img/9.b292d82f.png";